import { useMediaQuery } from './useMediaQuery';

/**
 * ShowroomPage.css의 세로 적층 브레이크포인트와 **같은 조건**이어야 합니다.
 *
 * 배치는 CSS가 하지만 "보기 모드 토글을 뷰어 위에 둘지, 패널 안에 둘지"는
 * DOM 위치 자체가 달라지는 문제라서 JS가 정해야 합니다. 그래서 같은 값이 두 곳에
 * 있습니다. CSS만 고치면 패널은 위아래로 쌓였는데 토글은 여전히 패널 안에 남고,
 * 여기만 고치면 토글이 데스크톱 레이아웃의 캔버스 위로 올라갑니다.
 * 둘 다 데스크톱 개발 중에는 눈에 띄지 않으므로 responsiveStyles.test.ts가 대조합니다.
 */
export const STACKED_LAYOUT_QUERY = '(orientation: portrait) and (max-width: 1100px)';

/**
 * 물리 키보드가 없다고 볼 조건.
 *
 * 정확히는 "포인터가 손가락인가"를 묻는 것입니다. 키보드 유무를 직접 알려주는 미디어
 * 쿼리는 없어서, 터치 기기라는 사실로 대신합니다. 안내 문구를 고르는 데만 쓰기 때문에
 * 틀려도 손해가 크지 않습니다 — 조작 자체는 키보드와 화면 버튼이 언제나 둘 다 살아
 * 있습니다(useDrivingInput).
 *
 * hover까지 함께 보는 이유는 터치와 마우스를 모두 가진 기기(터치 노트북, 태블릿 +
 * 트랙패드)를 키보드 있는 쪽으로 분류하기 위해서입니다. pointer: coarse만 보면 그
 * 기기에서 키보드 안내가 사라집니다.
 */
export const TOUCH_ONLY_QUERY = '(hover: none) and (pointer: coarse)';

/**
 * 뷰어와 패널이 위아래로 쌓이는 세로 레이아웃인지 알려줍니다.
 */
export function useStackedLayout(): boolean {
  return useMediaQuery(STACKED_LAYOUT_QUERY);
}

/** 손가락으로만 조작하는 기기인지 알려줍니다. 안내 문구를 고르는 데 씁니다. */
export function useTouchOnly(): boolean {
  return useMediaQuery(TOUCH_ONLY_QUERY);
}
